import ContentConfig from '../config/ContentConfig';

export default function getUrlPrefix(config: ContentConfig): string {
  if (config.agent.httpsEnabled) {
    return 'https://agent.kollective.app';
  }
  return 'http://localhost';
}
